
import React from 'react';
import Layout from '@/components/layout/Layout';
import RegisterForm from '@/components/auth/RegisterForm';
import { useLanguage } from '@/context/language-context';
import { Sparkles } from 'lucide-react';

const Register = () => {
  const { t } = useLanguage();
  
  return (
    <Layout>
      <div className="min-h-[80vh] flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-muted/30">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center p-2 bg-primary/10 rounded-full mb-4">
            <Sparkles className="h-6 w-6 text-primary" />
          </div>
          <h1 className="text-3xl font-bold">{t('Join Now')}</h1>
          <p className="text-muted-foreground mt-2 max-w-md mx-auto">
            {t('Create your account to access exclusive features and connect with others')}
          </p>
        </div>
        <RegisterForm />
      </div>
    </Layout>
  );
};

export default Register;
